// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__hOq0o","name":"Header_name__2Y_7g","birthday":"Header_birthday__1db59","skeleton":"Header_skeleton__3Zvry"};